import {
  Box,
  Column,
  Columns,
  ContentBlock,
  Heading,
  List,
  Stack,
  Text,
} from 'braid-design-system';

import { TextLink } from 'src/components/Link/Link';
import { Nav } from 'src/components/Nav/Nav';
import { PageWrapper } from 'src/components/PageWrapper/PageWrapper';
import { TRACKING_CODES } from 'src/constants';
import { links } from 'src/links';
import type { PageProps } from 'src/types';
import { slugify } from 'src/utils/slugify';

import { EnquiryForm } from './components/EnquiryForm/EnquiryForm';
import { SideInfo } from './components/SideInfo/SideInfo';

export const IntegrationRequest = ({ slug }: PageProps) => {
  const pageTrackingProps = {
    page: `${slugify({ str: slug })}`,
    eventName: `${slugify({ str: slug })}-viewed`,
    siteSection: 'partners',
  };

  return (
    <PageWrapper pageTrackingProps={pageTrackingProps} title={slug}>
      <Nav activeTab="integration-request" />
      <Box paddingY="xlarge" paddingX={['gutter', 'gutter', 'none']}>
        <ContentBlock>
          <Stack space="large">
            <Heading level="1">Integration Request for Partners</Heading>

            <Text>
              If you are a SEEK Customer looking to connect your SEEK account to
              one of our{' '}
              <TextLink
                href="/connected-partners/"
                tracking={TRACKING_CODES.connected_partners_link_clicked}
              >
                Connected Partners
              </TextLink>
              , please complete the form{' '}
              <TextLink
                href={links.LINK_YOUR_SOFTWARE.path}
                tracking={links.LINK_YOUR_SOFTWARE.tracking}
              >
                here
              </TextLink>
              .
            </Text>
            <Text weight="strong">
              Looking for a direct API integration with SEEK? Complete the form
              below.
            </Text>

            <Text>
              Please note each partnership opportunity is assessed individually
              to ensure the best fit and mutual benefit. To support us in
              evaluating your suitability to integrate with our solutions,
              please complete the form below in its entirety. Including as much
              detail as possible is crucial to support our evaluation.
            </Text>
            <SideInfo />
            <Stack space="medium">
              <Columns space="xlarge" collapseBelow="tablet">
                <Column>
                  <EnquiryForm />
                </Column>
                <Column width="1/4">
                  <Stack space="medium">
                    <Text weight="strong">
                      Not wanting to build an integration but still have an
                      enquiry?
                    </Text>
                    <List>
                      <Text>
                        Job seekers contact us{' '}
                        <TextLink
                          href="/contact-us/"
                          tracking={TRACKING_CODES.contact_us_link_clicked}
                          product="candidate"
                        >
                          here
                        </TextLink>
                      </Text>
                      <Text>
                        Employers contact us{' '}
                        <TextLink
                          href="/contactus/"
                          tracking={
                            TRACKING_CODES.talent_contact_us_link_clicked
                          }
                        >
                          here
                        </TextLink>
                      </Text>
                    </List>
                    <Text>
                      Or, search for answers in our{' '}
                      <TextLink
                        href="https://help.seek.com.au/employer/s/"
                        tracking={
                          TRACKING_CODES.talent_help_center_link_clicked
                        }
                        skipResolvedUrl={true}
                      >
                        Help center
                      </TextLink>
                      .
                    </Text>
                  </Stack>
                </Column>
              </Columns>
            </Stack>
          </Stack>
        </ContentBlock>
      </Box>
    </PageWrapper>
  );
};
